"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withFormulaMember = exports.thresholdChange = exports.shouldShowDelete = exports.isTextOnlyRule = exports.isOutsideFunction = exports.isBetweenFunction = exports.isBaseArgumentInFunction = exports.hasReachedMaxNestingDept = exports.getFormulaActions = exports.formulaType = exports.formulaChange = exports.deleteFormulaMember = exports.defaultPensionModel = exports.createInitialFormula = exports.areParanthesesEnabled = exports.areFunctionsEnabled = exports.addParanthesis = exports.addFunctionBetween = exports.addFunction = exports.addFormulaMember = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _react = _interopRequireDefault(require("react"));
var _uuid = require("uuid");
var _constants = require("./constants");
var _FormulaMember = _interopRequireDefault(require("./FormulaMember"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var functionMaxNestingDepth = 5;
var isPsOrContributionBase = function isPsOrContributionBase(focusedPath, builderData) {
  var last = R.takeLast(3, focusedPath);
  if (R.prop('value', R.path(focusedPath, builderData)) === 'pensionable salary') {
    return true;
  }
  if (R.prop(0, last) === 'contribution' && R.prop(2, last) === 0) {
    return true;
  }
  return false;
};
var isBaseArgumentInFunction = function isBaseArgumentInFunction(focusedPath) {
  var lastElems = R.takeLast(3, focusedPath);
  if (R.prop(0, lastElems) === 'arguments' && (R.prop(1, lastElems) === 0 || R.prop(1, lastElems) === 1) && R.prop(2, lastElems) === 0 || lastElems[0] === 'contribution' && lastElems[2] === 0) {
    return true;
  }
  return false;
};
exports.isBaseArgumentInFunction = isBaseArgumentInFunction;
var isOutsideFunction = function isOutsideFunction(newKeysPath) {
  return newKeysPath.slice(0, newKeysPath.length - 2).pop() === 'arguments' ? newKeysPath.slice().pop() !== 0 : true;
};
exports.isOutsideFunction = isOutsideFunction;
var isBetweenFunction = function isBetweenFunction(data, index, pensionFocusedElement) {
  var elem = R.path([pensionFocusedElement[0], 'thresholdRows', index], data);
  if (R.prop('isBetween', elem) || R.prop('min', elem) && R.prop('max', elem)) {
    return true;
  }
  return false;
};
exports.isBetweenFunction = isBetweenFunction;
var withFormulaMember = function withFormulaMember(requiredProps, props) {
  return /*#__PURE__*/_react["default"].createElement(_FormulaMember["default"], _extends({}, requiredProps, props));
};
exports.withFormulaMember = withFormulaMember;
var hasReachedMaxNestingDept = function hasReachedMaxNestingDept(path) {
  return R.filter(R.equals('arguments'), path).length >= functionMaxNestingDepth;
};
exports.hasReachedMaxNestingDept = hasReachedMaxNestingDept;
var areFunctionsEnabled = function areFunctionsEnabled(_ref) {
  var disabled = _ref.disabled,
    focusedElementType = _ref.focusedElementType,
    builderData = _ref.builderData,
    focusedPath = _ref.focusedPath;
  return !disabled && (focusedElementType === _constants.FORMULA_MEMBER_TYPES.operator || R.isEmpty(builderData) || isBaseArgumentInFunction(focusedPath) || focusedElementType === _constants.FORMULA_MEMBER_TYPES.functionMember || hasReachedMaxNestingDept(focusedPath));
};
exports.areFunctionsEnabled = areFunctionsEnabled;
var areParanthesesEnabled = function areParanthesesEnabled(_ref2) {
  var disabled = _ref2.disabled,
    focusedElementType = _ref2.focusedElementType,
    builderData = _ref2.builderData,
    focusedPath = _ref2.focusedPath;
  return !disabled && !isPsOrContributionBase(focusedPath, builderData) && !isBaseArgumentInFunction(focusedPath) && (focusedElementType === _constants.FORMULA_MEMBER_TYPES.variable || focusedElementType === _constants.FORMULA_MEMBER_TYPES.numeric || focusedElementType === _constants.FORMULA_MEMBER_TYPES.percentage || focusedElementType === _constants.FORMULA_MEMBER_TYPES.functionMember);
};
exports.areParanthesesEnabled = areParanthesesEnabled;
var defaultPensionModel = {
  contribution: {
    formulaItems: [{
      arguments: null,
      type: _constants.FORMULA_MEMBER_TYPES.variable,
      value: '',
      key: (0, _uuid.v4)()
    }]
  },
  thresholdRows: [{
    field: 'pensionable salary',
    max: null,
    min: null
  }]
};
exports.defaultPensionModel = defaultPensionModel;
var createInitialFormula = function createInitialFormula(data) {
  return [_objectSpread({
    key: (0, _uuid.v4)()
  }, data)];
};
exports.createInitialFormula = createInitialFormula;
var deleteFormulaMember = function deleteFormulaMember(formula) {
  return function (path) {
    var data = R.clone(formula);
    var parentKeysPath = path.slice();
    var childKey = parentKeysPath.pop();
    if (!R.path(path, data)) return false;
    if (isBaseArgumentInFunction(path)) {
      R.path(parentKeysPath, data).splice(childKey, 1, {
        key: (0, _uuid.v4)(),
        value: '',
        type: _constants.FORMULA_MEMBER_TYPES.variable,
        displayName: ''
      });
    } else {
      R.path(parentKeysPath, data).splice(childKey, 1);
    }
    return data;
  };
};
exports.deleteFormulaMember = deleteFormulaMember;
var addFormulaMember = function addFormulaMember(formula) {
  return function (currentElementType, path, value) {
    var data = R.clone(formula);
    var parentKeysPath = path.slice();
    var childKey = parentKeysPath.pop();
    R.path(parentKeysPath, data).splice(childKey + 1, 0, {
      key: (0, _uuid.v4)(),
      value: '',
      type: currentElementType === _constants.FORMULA_MEMBER_TYPES.operator || currentElementType === _constants.FORMULA_MEMBER_TYPES.parenthesis && value === '(' ? _constants.FORMULA_MEMBER_TYPES.variable : _constants.FORMULA_MEMBER_TYPES.operator,
      displayName: ''
    });
    return data;
  };
};
exports.addFormulaMember = addFormulaMember;
var addParanthesis = function addParanthesis(formula, type) {
  return function (path) {
    var data = R.clone(formula);
    var parentKeysPath = path.slice();
    var childKey = parentKeysPath.pop();
    R.path(parentKeysPath, data).splice(type === 'left' ? childKey : childKey + 1, 0, {
      key: (0, _uuid.v4)(),
      value: type === 'left' ? '(' : ')',
      type: _constants.FORMULA_MEMBER_TYPES.parenthesis,
      displayName: ''
    });
    return data;
  };
};
exports.addParanthesis = addParanthesis;
var addFunctionTypeAndTypeField = function addFunctionTypeAndTypeField(type) {
  if (_constants.roundFunctionTypes.includes(type)) {
    return {
      type: _constants.FORMULA_MEMBER_TYPES.numeric,
      dataType: _constants.DATA_TYPES.NUMERIC
    };
  }
  return {
    type: _constants.FORMULA_MEMBER_TYPES.variable,
    dataType: _constants.DATA_TYPES.MIXED
  };
};
var addFunction = function addFunction(formula, type) {
  return function (path) {
    var data = R.clone(formula);
    var parentKeysPath = path.slice();
    var childKey = parentKeysPath.pop();
    var focusedElement = R.path(path, data);
    var focusedType = R.prop('type', focusedElement);
    if (focusedType === _constants.FORMULA_MEMBER_TYPES.functionMember) {
      focusedElement.value = type;

      //when add/change function reset second argument
      var lastFocusedArgument = focusedElement.arguments[focusedElement.arguments.length - 1][0];
      focusedElement.arguments = R.update(1, [_objectSpread(_objectSpread(_objectSpread({}, lastFocusedArgument), _constants.DEFAULT_FUNCTION_ARGUMENT), addFunctionTypeAndTypeField(type))], focusedElement.arguments);
      return data;
    }
    if (isBaseArgumentInFunction(path)) {
      childKey = R.takeLast(2);
      R.path(parentKeysPath, data).splice(childKey, 1);
    }
    R.path(parentKeysPath, data).splice(childKey + 1, 0, {
      key: (0, _uuid.v4)(),
      value: type,
      type: _constants.FORMULA_MEMBER_TYPES.functionMember,
      arguments: [[_objectSpread({
        key: (0, _uuid.v4)()
      }, _constants.DEFAULT_FUNCTION_ARGUMENT)], [_objectSpread(_objectSpread({
        key: (0, _uuid.v4)()
      }, _constants.DEFAULT_FUNCTION_ARGUMENT), addFunctionTypeAndTypeField(type))]]
    });
    return data;
  };
};
exports.addFunction = addFunction;
var formulaChange = function formulaChange(formula) {
  return function (data, path) {
    var elements = R.clone(formula);
    var updatedElement = R.path(path, elements);
    updatedElement.value = data.value;
    updatedElement.description = data.description;
    updatedElement.dataSource = data.dataSource;
    updatedElement.displayName = data.label || data.displayName || '';
    updatedElement.type = data.type;
    return elements;
  };
};
exports.formulaChange = formulaChange;
var thresholdChange = function thresholdChange(threshold) {
  return function (type, _ref3) {
    var thresholdIndex = _ref3.thresholdIndex,
      sourceThreshold = _ref3.sourceThreshold,
      thresholdData = _ref3.thresholdData;
    var ruleThresholds = R.clone(threshold);
    switch (type) {
      case 'update':
        {
          ruleThresholds[thresholdIndex] = thresholdData;
          break;
        }
      case 'add':
        {
          ruleThresholds = R.insert(thresholdIndex + 1, _objectSpread({
            name: "threshold-".concat(ruleThresholds.length),
            key: (0, _uuid.v4)()
          }, defaultPensionModel), ruleThresholds);
          break;
        }
      case 'duplicate':
        {
          ruleThresholds = R.insert(thresholdIndex + 1, _objectSpread(_objectSpread({}, sourceThreshold), {}, {
            key: (0, _uuid.v4)(),
            name: "threshold-".concat(ruleThresholds.length)
          }), ruleThresholds);
          break;
        }
      case 'delete':
        {
          ruleThresholds.splice(thresholdIndex, 1);
          break;
        }
      default:
    }
    return ruleThresholds;
  };
};
exports.thresholdChange = thresholdChange;
var addFunctionBetween = function addFunctionBetween(threshold) {
  return function (thresholdIndex, blockIndex) {
    var ruleThresholds = R.clone(threshold);
    ruleThresholds[thresholdIndex].thresholdRows[blockIndex].isBetween = true;
    ruleThresholds[thresholdIndex].thresholdRows[blockIndex].min = null;
    ruleThresholds[thresholdIndex].thresholdRows[blockIndex].max = null;
    ruleThresholds[thresholdIndex].thresholdRows[blockIndex].isInclusive = true;
    return ruleThresholds;
  };
};
exports.addFunctionBetween = addFunctionBetween;
var enhancedRuleChange = function enhancedRuleChange(field, formula, ruleChange, other) {
  if (field === 'complex') {
    var complex = other.rule.complex;
    var activeType = complex.activeType;
    var complexObject = _objectSpread(_objectSpread({}, complex), {}, _defineProperty({}, activeType, _objectSpread(_objectSpread({}, complex[activeType]), {}, _defineProperty({}, other.key, formula))));
    return ruleChange(field, complexObject, false, true);
  }
  return ruleChange(field, formula, false, true);
};
var getFormulaActions = function getFormulaActions(field, source, ruleChange) {
  var other = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  return {
    addFormulaMember: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addFormulaMember(source)),
    deleteFormulaMember: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, deleteFormulaMember(source)),
    addFunctionMin: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addFunction(source, _constants.FUNCTION_MEMBER_TYPES.MIN)),
    addFunctionMax: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addFunction(source, _constants.FUNCTION_MEMBER_TYPES.MAX)),
    addFunctionRound: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addFunction(source, _constants.FUNCTION_MEMBER_TYPES.ROUND)),
    addFunctionRoundUp: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addFunction(source, _constants.FUNCTION_MEMBER_TYPES.ROUND_UP)),
    addFunctionRoundDown: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addFunction(source, _constants.FUNCTION_MEMBER_TYPES.ROUND_DOWN)),
    addLeftBracket: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addParanthesis(source, _constants.FUNCTION_MEMBER_TYPES.LEFT)),
    addRightBracket: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addParanthesis(source, _constants.FUNCTION_MEMBER_TYPES.RIGHT)),
    formulaChange: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, formulaChange(source)),
    thresholdChange: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, thresholdChange(source)),
    addFunctionBetween: R.compose(function (formula) {
      return enhancedRuleChange(field, formula, ruleChange, other);
    }, addFunctionBetween(source))
  };
};
exports.getFormulaActions = getFormulaActions;
var isTextOnlyRule = R.compose(R.propEq('type', _constants.FORMULA_MEMBER_TYPES.textOnly), R.head);
exports.isTextOnlyRule = isTextOnlyRule;
var formulaType = R.compose(R.prop('type'), R.head);
exports.formulaType = formulaType;
var shouldShowDelete = function shouldShowDelete(_ref4) {
  var noDelete = _ref4.noDelete,
    isFocused = _ref4.isFocused,
    keysPath = _ref4.keysPath,
    isBaseInFunction = _ref4.isBaseInFunction,
    type = _ref4.type;
  return !noDelete && isFocused && (isOutsideFunction(keysPath) || isBaseInFunction && type === _constants.FORMULA_MEMBER_TYPES.functionMember);
};
exports.shouldShowDelete = shouldShowDelete;
withFormulaMember.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "withFormulaMember"
};